import WorksiteDetailScreen from '@/features/worksites/components/worksite-detail-screen';
import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import z from 'zod';

export const worksiteTabSchema = z.object({
  tab: fallback(z.enum(['suivi', 'journal']).optional(), undefined).optional(),
  // File de modération du journal (FR-04) : dans l'URL comme l'onglet, pour
  // qu'un modérateur puisse s'y rendre — et y renvoyer quelqu'un — d'un lien.
  file: fallback(z.enum(['propositions']).optional(), undefined).optional(),
  // Déroulé complet au téléphone : c'est une PAGE, pas un panneau — le bouton
  // Retour doit la fermer, et un lien doit pouvoir y mener.
  deroule: fallback(z.literal('ouvert').optional(), undefined).optional(),
});
// `worksites_` : la fiche n'est PAS imbriquée sous la liste — elle occupe
// l'écran, elle n'en est pas un panneau.
export const Route = createFileRoute('/_app/worksites_/$worksiteId')({
  validateSearch: zodValidator(worksiteTabSchema),
  component: WorksiteDetailScreen,
});
